import { Box, Heading, Text, List, ListItem } from '@chakra-ui/react'
import { CheckCircleIcon } from '@chakra-ui/icons'

const FinalTips = () => (
  <Box>
    <Heading as="h4" size="md" mt={6} mb={2} color="green.600">
      Final Implementation Tips
    </Heading>
     <List spacing={2} mb={4}>
      <ListItem>
        <CheckCircleIcon color='green.500' mr={2} />
        <Text as="span" fontSize="sm">Start with paper trading for at least 30 days to become comfortable with the system</Text>
      </ListItem>
       <ListItem>
        <CheckCircleIcon color='green.500' mr={2} />
        <Text as="span" fontSize="sm">Keep a detailed log of all signals and your execution of them</Text>
      </ListItem>
      <ListItem>
        <CheckCircleIcon color='green.500' mr={2} />
        <Text as="span" fontSize="sm">Review your performance monthly, focusing on adherence to the rules rather than returns</Text>
      </ListItem>
       <ListItem>
        <CheckCircleIcon color='green.500' mr={2} />
        <Text as="span" fontSize="sm">Consider automating parts of the process to reduce emotional decision-making</Text>
      </ListItem>
       <ListItem>
        <CheckCircleIcon color='green.500' mr={2} />
        <Text as="span" fontSize="sm">Remember that no strategy works in all market conditions - expect periods of underperformance</Text>
      </ListItem>
    </List>
     <Text mt={4} fontStyle="italic">
      This strategy's strength lies in its simplicity and clear rules. By consistently following the Good/Very Bad ratio signals and maintaining proper position sizing, you can achieve results that significantly outperform a simple buy-and-hold approach while experiencing much lower drawdowns.
    </Text>
  </Box>
)

export default FinalTips
